import { useEffect, useRef } from 'react';
import { JobStatus } from 'libs.jobs.common';
import { useLocalizeMessage, useToastNotification } from 'libs.nucleus';
import { useJobs } from '../hooks/use_jobs.hook';
import { useJobsAck } from '../hooks/use_jobs_ack.hook';
export function JobsManager({ children }) {
    const { isLoading, values, error } = useJobs({ status: [JobStatus.ERROR, JobStatus.DONE] });
    const ack = useJobsAck();
    const { addNotification } = useToastNotification();
    const translate = useLocalizeMessage();
    const isAck = useRef({});
    useEffect(() => {
        var _a, _b;
        if (isLoading || error || !values) {
            return;
        }
        for (const { jobId, status, completion_message, error_message } of values) {
            if (isAck.current[jobId]) {
                continue;
            }
            isAck.current[jobId] = true;
            if (status === JobStatus.DONE) {
                const title = translate((_a = completion_message === null || completion_message === void 0 ? void 0 : completion_message.message_key) !== null && _a !== void 0 ? _a : 'Success');
                addNotification({ title, type: 'success' });
            }
            if (status === JobStatus.ERROR) {
                const title = translate((_b = error_message === null || error_message === void 0 ? void 0 : error_message.message_key) !== null && _b !== void 0 ? _b : 'Error');
                addNotification({ title, type: 'error' });
            }
            ack(jobId);
        }
    }, [isLoading, values, error]);
    return children;
}
//# sourceMappingURL=jobs_manager.component.js.map